module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/preface",
      "id": "preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/notetothereader",
      "id": "rnotetothereader"
    }
  }, [_vm._v("Note to the Reader")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction",
      "id": "intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01",
      "id": "ch01"
    }
  }, [_vm._v("1. Porter and Mexican Politics")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02",
      "id": "ch02"
    }
  }, [_vm._v("2. Porter in Mexico, 1920–1921")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "id": "ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Porter and Mexican Art, 1922 and 1923")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "id": "ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Thinking of Mexico, 1924–1930")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "id": "ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Mexico Once More, 1930–1931")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "id": "ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Becoming Miranda")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "id": "ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('i', [_vm._v("Ship of Fools")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/conclusion",
      "id": "con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/notes",
      "id": "notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "id": "bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "id": "index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgments",
      "id": "ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Permissions Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/photos#rphoto1",
      "id": "photo1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0